'use client'

import { useState } from 'react'

import cn from 'clsx'

import Filter from './Filter'
import Position from './Position'

import s from './Careers.module.sass'

function Careers({ title, positions }: { title?: string, positions: any[] }) {
    const [selectedLocation, setSelectedLocation] = useState<string[]>([])
    const [selectedType, setSelectedType] = useState<string[]>([])
    const [selectedBranch, setSelectedBranch] = useState<string[]>([])

    const _positions = positions?.filter((position) => {
        const locationMatch =
            selectedLocation.length > 0
                ? position?.location
                    ? selectedLocation.includes(position?.location?.toLowerCase())
                    : true
                : true
        const typeMatch =
            selectedType.length > 0 ? (position?.position ? selectedType.includes(position?.position?.toLowerCase()) : true) : true
        const branchMatch =
            selectedBranch.length > 0 ? (position?.branch ? selectedBranch.includes(position?.branch?.toLowerCase()) : true) : true
        return locationMatch && typeMatch && branchMatch
    })

    return (
        <section className={s.Careers}>
            <div className={cn(s.Cont, 'container')}>
                {title && <h2 dangerouslySetInnerHTML={{ __html: title }} />}
                <Filter
                    selectedLocation={selectedLocation}
                    setSelectedLocation={setSelectedLocation}
                    selectedType={selectedType}
                    setSelectedType={setSelectedType}
                    selectedBranch={selectedBranch}
                    setSelectedBranch={setSelectedBranch}
                />
                <div className={cn(s.Count, 'smallCaps')}>
                    {_positions?.length === 0 ? (
                        <div className={s.Reset}>
                            No positions found.
                            <button
                                onClick={() => {
                                    setSelectedLocation([])
                                    setSelectedType([])
                                    setSelectedBranch([])
                                }}
                            >
                                Reset filters.
                            </button>
                        </div>
                    ) : (
                        `Showing ${_positions?.length} positions.`
                    )}
                </div>
                {positions && (
                    <div className={s.Positions}>
                        {_positions?.map((position, index) => <Position position={position} key={index} />)}
                    </div>
                )}
            </div>
        </section>
    )
}

export default Careers
